import { render, staticRenderFns } from "./Calendarios.vue?vue&type=template&id=571964a3&scoped=true"
import script from "./Calendarios.vue?vue&type=script&lang=js"
export * from "./Calendarios.vue?vue&type=script&lang=js"
import style0 from "./Calendarios.vue?vue&type=style&index=0&id=571964a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571964a3",
  null
  
)

export default component.exports